import { useQuery } from 'react-query'
import { getCountries } from 'services/requests/countries'

export const useGetCountries = () => {
	return useQuery(
		['countries'],
		getCountries
	)
}
